<template>
  <b-modal
    id="availablecredits"
    size="lg"
    ref="availablecredits"
    body-class="bg-white"
    cancel-title="Close"
    cancel-variant="light"
    :ok-title-html="submitted==true?loaderIcon+'Apply Credits':'Apply Credits'"
    :title="'Apply credits'"
    :ok-disabled="submitted"
    :no-close-on-backdrop="true"
    @shown="createFreshObject()"
    @ok.prevent="onSubmit()"
    :lazy="true"
  >
    <b-alert
      class="alert-transparent alert-danger"
      :show="alertShow= error_show && this.errors.any()"
    >
      <button type="button" @click="error_show = !error_show" class="close">
        <span aria-hidden="true">&times;</span>
      </button>

     <div v-for="item in errors.items" :key="item.id" >
       <p class="fw-semi-bold" v-if="item.field=='Paid Amount'">
            The paid amount should not be greater than Invoice Balance Due</p>
        <p class="fw-semi-bold" v-else>{{ item.msg }}</p>
            </div>
    </b-alert>
    <span class="text-bold float-right">
      <strong>{{ currency+parseFloat(field.due_amount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</strong>
    </span>
    <span class="text-bold float-right mr-2">
      <strong>Invoice Balance Due:</strong>
    </span>
    <br />
    <!--  table for showing availabel credit details -->
    <div class="table-responsive mt-4">
      <table class="table table-hover">
        <thead>
          <th>CREDIT NOTE</th>
          <th>CREDIT NOTE DATE</th>
          <th class="text-right">CREDIT AMOUNT</th>
          <th class="text-right">CREDIT AVAILABLE</th>
          <th class="text-right">AMOUNT TO CREDIT</th>
          <th></th>
        </thead>
        <tbody>
          <tr v-for="(item,index) in items" :key="item.id">
            <td>{{ item.crdt_no }}</td>
            <td>{{ getDateFormat(item.crdt_date) }}</td>
            <td
              class="text-right"
            >{{ currency+parseFloat(item.received_amount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
            <td
              class="text-right"
            >{{ currency+parseFloat(item.available_amount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
            <td>
              <input
                type="text"
                class="form-control text-right"
                v-model.trim="item.used_amount"
                :name="'used_amount['+index+']'"
                :data-vv-name="'row '+(index +1)+' amount to credit'"
                @blur=" total(),checkAdvance(index)"
                 v-validate="'max_value:'+parseFloat(item.available_amount).toFixed(2)"
              />
            </td>
            <td></td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td colspan="4" class="text-right">Amount to Credit:</td>
            <td class="text-right">{{ currency+header.paid_amount }}</td>
          </tr>
          <tr>
            <td colspan="4" class="text-right" style="border-top:none">Invoice Balance Due:</td>
            <td class="text-right" style="border-top:none">{{ currency+field.inv_due_amount }}</td>
          </tr>
        </tfoot>
      </table>
      <input
        type="hidden"
        name="paid_amount"
        data-vv-name="Paid Amount"
        :value="header.paid_amount"
        v-validate="'required|between:0,'+field.due_amount+'|excluded:'+parseFloat(0).toFixed(2)+'|max_value:'+parseFloat(field.due_amount).toFixed(2)"
      />
    </div>
  </b-modal>
</template>
<script>
import { mapState } from "vuex";
import store from "@/store/index";
import { notificationMixin } from "@/mixins/notification";

import { EventBus } from "@/event-bus.js"; // call bus event to access child component method from parent component

export default {
  props: ["field", "currency", "place_of_supply"], // field data form parent component
  mixins: [notificationMixin], // for showing message notification
  data() {
    return {
      loaderIcon: `<i class="fa fa-circle-o-notch fa-spin mr-2"></i>`,
      submitted: false,
      check: {},
      header: {
        paid_amount: "0.00"
      },
      alertShow: "", // to show the error message
      error_show: false, // to show the error message
      items: [], // credit available details
      locationClasses: "messenger-fixed messenger-on-top messenger-on-center" // class for notification message design
    };
  },
  methods: {
    checkAdvance(i) {
      if (
        this.items[i].pymnt_type == 4 &&
        this.items[i].place_of_supply != this.place_of_supply &&
        this.items[i].used_amount > 0
      ) {
        this.check[i] = 1;
      } else {
        delete this.check[i];
      }
    },
    // calculation for using credit amount for tallyign invoice
    total() {
      var header_due_amount = parseFloat(this.field.due_amount);
      var header_amount = this.items.reduce(function(total, value) {
        var available_amount = parseFloat(value.available_amount);
        var used_amount = parseFloat(value.used_amount);
        if (used_amount > available_amount || used_amount > header_due_amount) {
          value.used_amount =
            header_due_amount <= available_amount
              ? header_due_amount
              : available_amount;
        }
        header_due_amount -= value.used_amount;
        return !isNaN(parseFloat(value.used_amount))
          ? total + parseFloat(value.used_amount)
          : parseFloat(total);
      }, 0);
      this.header.paid_amount = header_amount.toFixed(2);
      var due_amount =
        parseFloat(this.field.due_amount) - parseFloat(header_amount);
      this.field.inv_due_amount = due_amount.toFixed(2);
    },
    createFreshObject() {      
      this.header.paid_amount = "0.00";
      this.field.inv_due_amount = parseFloat(this.field.due_amount).toFixed(2);
    },
    creditdetails() {
      store
        .dispatch(
          "invoice/creditsavailable",
          JSON.stringify({ id: this.field.id })
        )
        .then(() => {
          if(this.status_code!=200){
        this.$emit("checkCustomer",{status_message:this.status_message,status_type:this.status_type})
      }else{
          this.items = this.credit_details;
      }
        });
    },
    onSubmit() {
      if (Object.entries(this.check).length > 0) {
        window.Messenger().post({
          extraClasses: "messenger-fixed messenger-on-top messenger-on-center",
          message:
            "Cannot apply Customer Payment to Invoice, Since it has different Place Of Supply.",
          type: "danger",
          showCloseButton: true
        });
        return;
      }
      this.$validator.validateAll().then(result => {
        if (result) {
          this.submitted = true;
          this.$refs.availablecredits.hide();

          var data = JSON.stringify({
            id: this.$route.params.id,
            field: {
              id: this.field.id,
              paid_amount: this.header.paid_amount,
              due_amount: this.field.inv_due_amount
            },
            items: this.items
          });

          store.dispatch("invoice/updateCredits", data).then(() => {
            this.submitted = false;
            if(this.status_code==200){
            //  update the page details and field detials
            this.field.due_amount = parseFloat(
              this.invoice_credit_updated_details.invoice_amount_detail
                .due_amount
            ).toFixed(2);
            this.field.inv_due_amount = parseFloat(
              this.invoice_credit_updated_details.invoice_amount_detail
                .due_amount
            ).toFixed(2);
            //  update the view page amount details
            this.invoice_credit_details = this.invoice_credit_updated_details.invoice_credit_details; // update credit used details
            this.invoice_payment_details = this.invoice_credit_updated_details.invoice_payment_details; // update credit used details
            this.invoice_amount_detail = this.invoice_credit_updated_details.invoice_amount_detail; // update footer invoice maount detials
            this.available_credits = this.invoice_credit_updated_details.available_credits; //update availble credit details
            }
           window.Messenger().post({
              extraClasses:
                "messenger-fixed messenger-on-top messenger-on-center",
              message: this.status_message,
              type: this.status_type,
              showCloseButton: true
            });
          });
        } else {
          this.submitted = false;
          this.error_show = true; // show validation message
        }
      });
    }
  },
  mounted() {
    EventBus.$on("creditdetails", this.creditdetails); // to trigger the method from parentcomponent
  },
  created() {
    this.initializationMessengerCode();
    window.Messenger.options = {
      extraClasses: this.locationClasses,
      theme: "air"
    };
  },
  computed: {
    ...mapState({
      credit_details: (state) => state.invoice.credit_details,
      type: (state) => state.invoice.type,
      message: (state) => state.invoice.message,
      invoice_credit_updated_details: (state) =>
        state.invoice.invoice_credit_details,
      status_code: (state) => state.invoice.status_code,
      status_message: (state) => state.invoice.status_message,
      status_type: (state) => state.invoice.status_type,
    }),

    //  to update applied credit amount in the invoice page
    invoice_credit_details: {
      get() {
        return this.$store.state.invoice.list.invoice_credit_details;
      },
      set(val) {
        this.$store.state.invoice.list.invoice_credit_details = val;
      }
    },
    // to update balce due amount after inovice credit update
    invoice_amount_detail: {
      get() {
        return this.$store.state.invoice.list.invoice_amount_detail;
      },
      set(val) {
        this.$store.state.invoice.list.invoice_amount_detail = val;
      }
    },
    // to udpate the credit details tab
    available_credits: {
      get() {
        return this.$store.state.invoice.list.available_credits;
      },
      set(val) {
        this.$store.state.invoice.list.available_credits = val;
      }
    },
    //  to update applied credit amount in the invoice page
    invoice_payment_details: {
      get() {
        return this.$store.state.invoice.list.invoice_payment_details;
      },
      set(val) {
        this.$store.state.invoice.list.invoice_payment_details = val;
      }
    }
  }
};
</script>
<style>
.required:after {
  color: #e32;
  content: " *";
  display: inline;
}
</style>